module.exports = __webpack_public_path__ + "static/top_process_bg-8591601373f4e5678904799943fdb14b.jpg";